import { FC } from 'react';
import { Error } from '@doda/io-react/common';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { IncomeHooksType } from 'components/SearchConditionSettingForm/types';
import classNames from 'classnames';
import styles from './index.module.scss';
import { SearchIncomeSelect } from '../SearchIncomeSelect';

/** 検索条件設定コンポーネント 収入 Props */
interface Props {
  /** 収入関連のフックタイプ */
  income: IncomeHooksType;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
}

/**
 * 検索条件設定コンポーネント 収入
 *
 * @param {Props} props - 収入の検索条件設定に必要なプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const IncomeContents: FC<Props> = ({ income, updateJobCount }) => {
  const {
    upperIncome,
    lowerIncome,
    setLowerIncome,
    setUpperIncome,
    isIncomeRangeError,
    setIsIncomeRangeError,
    updateUpperIncome,
    updateLowerIncome,
  } = income;
  return (
    <>
      <div
        className={classNames(styles.searchIncome__wrapper, {
          [styles.searchIncome__wrapper__error]: isIncomeRangeError,
        })}
      >
        <SearchIncomeSelect
          isUpper={false}
          onChange={updateLowerIncome}
          defaultValue={lowerIncome}
          upperIncome={upperIncome}
          lowerIncome={lowerIncome}
          setIncome={(value) => setLowerIncome(value)}
          setIsIncomeRangeError={() => setIsIncomeRangeError(true)}
          updateJobCount={updateJobCount}
        />
        <SearchIncomeSelect
          isUpper
          onChange={updateUpperIncome}
          defaultValue={upperIncome}
          upperIncome={upperIncome}
          lowerIncome={lowerIncome}
          setIncome={(value) => setUpperIncome(value)}
          setIsIncomeRangeError={() => setIsIncomeRangeError(true)}
          updateJobCount={updateJobCount}
        />
      </div>
      {isIncomeRangeError && (
        <p className={styles.searchIncome__error}>
          <Error size="M" />
          年収の指定が間違っています。正しい範囲を指定してください。
        </p>
      )}
    </>
  );
};
